import React, { Component } from "react";
import { Card, CardHeader, CardBody, Box, HStack, Text, Spacer, Square } from '@chakra-ui/react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faArrowCircleDown, faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";

import LocalStorageService from "../../../../services/LocalStorageService";
import CoreService from "../../../../services/CoreService";


ChartJS.register(ArcElement, Tooltip, Legend);


export const options = {
  plugins: {
    title: {
      display: true,
      text: 'Filtered Grade Chart',
    }
  },
  responsive: true,
};

function toPieData(apiData, pieColors, randColors) {
  const rawLabels = apiData.map((rec) => {
    let pctStr = (rec.pct < 1) ? "<1" : rec.pct;
    return rec.countProp + " (" + pctStr + "%)";
  });
  const rawData = apiData.map((rec) => {
    return rec.count;
  });

  const rawBkg = apiData.map((rec) =>{
    return getPieColor(rec.countProp, pieColors, randColors);
  })

  //const rawBkg = pieColors.map((color) => {
   // return color.id
  //});
  var result = { labels: rawLabels, data: rawData, backgroundColor: rawBkg };
  return result;
}

function getPieColor(grade, pieColors, randColors)
{
  var result = pieColors.find((pc) => pc.name.toLowerCase() === grade.toLowerCase());
  if (!result)
  {
    let randResult = getRandomElement(randColors);
    
    return randResult.id;
    //result = pieColors.find((pc) => pc.name.toLowerCase() === "default");
    //if (!result) return "#e0e6ea";
  }
  return result.id;
}


function getRandomElement(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export default class FilteredCountPieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pieData: [{ data: [100], backgroundColor: "white" }],
      pieLabels: ["Loading.."],
      isLoading: true,
      moreCaret: "caret-up",
      isCollapsed: false,
      pieColors: []
    };

    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();

    this.refreshPieData = this.refreshPieData.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  async componentDidMount() {
    if (this.props.searchParams) {
      await this.refreshPieData();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.searchParamsKey !== prevProps.searchParamsKey) {
      await this.refreshPieData();
    }
  }

  async refreshPieData() {
    this.setState({ isLoading: true });
    var schema = this.localStorageService.getSchema(this.props.currentSchemaId);
    var colors = this.localStorageService.getDataList("colormap-grade",this.props.userSession.gcid);
    var randColors = this.localStorageService.getDataList("colormap-base", this. props.userSession.gcid)
    console.log("trying to get color datalist");
    console.log(colors.data.data);
    this.setState({
      pieColors: colors.data.data,
      randColors: randColors.data.data
    })
    // this.props.countProp
    // this.props.title

    var apiResult = await this.coreService.fetchCountPctByPropResult(this.props.countProp, this.props.searchParams, schema?.search ?? {}, this.props.userSession.gcid, this.props.userSession.token);
    if (apiResult.hasError) {
      // TBD: we should show this in the chart box
      return;
    }

    //var pieDataResponse = await this.coreService.fetchObsGradePieList(this.props.searchParams, schema?.search ?? {}, this.props.userSession.gcid, this.props.userSession.token);
    var conformedData = toPieData(apiResult.dataResult.data, this.state.pieColors, this.state.randColors);
    var newPieData = [
      {
        data: conformedData.data,
        backgroundColor: conformedData.backgroundColor,
      },
    ];
    var newPieLabels = conformedData.labels;
    this.setState({
      pieData: newPieData,
      pieLabels: newPieLabels,
      isLoading: false,
    });
  }

  toggleCollapse() {
    let newIsCollapsed = !this.state.isCollapsed;
    let newCaretState = newIsCollapsed ? "caret-down" : "caret-up";
    this.setState({
      isCollapsed: newIsCollapsed,
      moreCaret: newCaretState,
    });
  }

  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    return (
      <Box p='4' alignItems='center' backgroundColor={"white"} borderRadius={"5px"} margin="1" w='-webkit-fill-available'>
        <HStack>
          <Spacer />
          <Text fontSize={{ base: '16px', md: '20px', lg: '28x' }} >{(this.props.title) ? this.props.title : "Grade Chart"}</Text>

          <Spacer />
          <FontAwesomeIcon icon={(this.state.isCollapsed) ? faArrowCircleDown : faArrowCircleUp} onClick={() => this.toggleCollapse()} />
          {loadingIcon}
        </HStack>
        {!this.state.isCollapsed ? (

          <Pie
            data={{
              datasets: this.state.pieData,
              labels: this.state.pieLabels,
            }}
            legend={{ position: "left", align: "left" }}
          />


        ) : (
          <span />
        )}

      </Box>
    );
  }
}
